/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateUserModel as DigiworkMaitreDDtoAuthenticationUpdateUserModel } from '../../models/Digiwork/MaitreD/DTO/Authentication/update-user-model';

export interface UpdateUserPofile$Params {
      body?: DigiworkMaitreDDtoAuthenticationUpdateUserModel
}

export function updateUserPofile(http: HttpClient, rootUrl: string, params?: UpdateUserPofile$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateUserPofile.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateUserPofile.PATH = '/api/wtr/User/updateuserpofile';
